function currencyFormat(num) {
  return num.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

function currencyFormatINR(num) {
  return num.replace(/(\d)(?=(\d\d)+\d$)/g, '$1,');
}

const formatBookingHubAmount = (value, currency) => {
  if (value === null || value === undefined) return '0.00';
  const sValue = value.toString().replace(/,/g, '');
  const toFixed = (currency && currency.toFixed) !== undefined ? currency.toFixed : 2;
  const fVal = parseFloat(sValue).toFixed(toFixed);
  const parts = fVal.split('.');
  
  let left = parts[0];
  if (currency && currency.countryAlpha2 === 'IN') {
    left = currencyFormatINR(parts[0]);
  } else if (currency && currency.countryAlpha2 === 'US') {
    left = currencyFormat(parts[0]);
  }
  return `${left}.${parts.length > 1 ? parts[1] : '00'}`;
};

export default formatBookingHubAmount;
